import { Agreement, MortgageDataObject } from '../types/models/agreement';

type AgreementView = Pick<Agreement, 'company' | 'policyType' | 'dataObject'>;

export const isMortgage = (agreement: Pick<Agreement, 'policyType'>): boolean =>
  agreement.policyType === 'mortgage';

/** Состав dataObject у ипотеки свой (clientService собирает его из mortgageAgreements) */
export const getMortgageData = (agreement: AgreementView): MortgageDataObject | undefined =>
  isMortgage(agreement) ? (agreement.dataObject as unknown as MortgageDataObject) : undefined;

/**
 * Код СК для логотипа, названия и фильтра. У ипотеки в company лежит псевдо-код
 * партнёра polisonline, реальная компания приходит отдельным полем.
 */
export const getAgreementCompanyCode = (agreement: AgreementView): string =>
  getMortgageData(agreement)?.companyCode || agreement.company;

export const getInsurerFullName = (data?: MortgageDataObject): string => {
  const parts = [data?.insurer?.lastName, data?.insurer?.firstName, data?.insurer?.middleName];
  return parts.filter(Boolean).join(' ') || '—';
};
